export { AwardedContractsComponent } from './awarded-contracts.component';

